import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	plans: {
		id: 'portfolio-3-portfolio.app-confluence-macro.main-new.plans',
		defaultMessage: 'Plans',
		description: 'Feature name in the title of the browser',
	},
});

export default messages;
